import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import React, { PureComponent } from 'react';
import hooks from '@g4/automation-hooks';

import oldTheme from '../Colors';

const Cell = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const CardSide = styled(Cell)`
  /* GMOB-327: adjust content and side padding to fit text */
  flex-shrink: 0;
`;

CardSide.propTypes = {
  /** Internal spacing defined as an index of `theme.layout.spacing` */
  spacing: PropTypes.number,
};

CardSide.defaultProps = {
  spacing: 2,
};

export const CardContent = styled(Cell)`
  flex-grow: 1;
  padding: ${props => props.theme.spacing(props.spacing)};
`;

export class Card extends PureComponent {
  static propTypes = {
    /** Size of card */
    size: PropTypes.oneOf(['small', 'large']),
    /** all component children nodes */
    children: PropTypes.node,
    /** It injects the generated stylesheet */
    className: PropTypes.string,
    /** Internal content spacing defined as an index of `theme.layout.spacing` */
    spacing: PropTypes.number,
    /** Applies cosmetics to highlight a recommendation or advertisement */
    promo: PropTypes.bool,
    /** Associates a specific action onto an element for the benefit of automated clients consuming it */
    automationHook: PropTypes.string,
  };

  static defaultProps = {
    spacing: 2,
    promo: false,
  };

  render() {
    return (
      <div
        className={this.props.className}
        {...hooks.hook(this.props.automationHook)}
      >
        {React.Children.map(this.props.children, child =>
          React.cloneElement(child, {
            spacing: this.props.spacing,
          })
        )}
      </div>
    );
  }
}

// Todo: Outer component spacing should not be assumed in a component library
export default styled(Card)`
  margin-bottom: 0.625rem;
  color: ${props => oldTheme.colors.modern.card.text};
  background: ${props => oldTheme.colors.modern.card.background};
  display: flex;
  box-shadow: inset 0 1px 0 0 ${props => oldTheme.colors.modern.card.stroke},
    1px 0 0 0 ${props => oldTheme.colors.modern.card.stroke},
    -1px 0 0 0 ${props => oldTheme.colors.modern.card.stroke},
    0 1px 0 0 ${props => oldTheme.colors.modern.card.stroke};

  ${props =>
    props.promo &&
    css`
      background: ${props => oldTheme.colors.modern.card.promo};
    `};
`;
